import React from "react";

// Ambient morphing liquid-glass background blobs (GPU-accelerated only).
export const LiquidBackground = ({ className = "" }) => (
  <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
    <div className="absolute -top-40 -left-32 h-[38rem] w-[38rem] rounded-full bg-amber/20 blur-[130px] animate-blob" />
    <div
      className="absolute top-1/3 -right-40 h-[34rem] w-[34rem] rounded-full bg-gold/15 blur-[140px] animate-blob"
      style={{ animationDelay: "-8s" }}
    />
    <div
      className="absolute bottom-0 left-1/3 h-[30rem] w-[30rem] rounded-full bg-amber/10 blur-[120px] animate-blob"
      style={{ animationDelay: "-15s" }}
    />
  </div>
);
